'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _marketingConversion = require('./marketingConversion.html');

var _marketingConversion2 = _interopRequireDefault(_marketingConversion);

var _marketingConversion3 = require('./marketingConversion.controller');

var _marketingConversion4 = _interopRequireDefault(_marketingConversion3);

require('./marketingConversion.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var marketingConversionComponent = {
  restrict: 'E',
  bindings: {},
  template: _marketingConversion2.default,
  controller: _marketingConversion4.default
};

exports.default = marketingConversionComponent;


// WEBPACK FOOTER //
// ./client/app/components/reports/marketingConversion/marketingConversion.component.js